import { render, staticRenderFns } from "./InscricaoTime.vue?vue&type=template&id=255e117a&"
import script from "./InscricaoTime.vue?vue&type=script&lang=js&"
export * from "./InscricaoTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports